import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { Languages, Gauge } from "lucide-react";

const MODES = [
  { key: "layman", label: "Layman" },
  { key: "balanced", label: "Balanced" },
  { key: "developer", label: "Developer" },
];
const COMPLEXITY = ["simple", "balanced", "detailed"];

export default function HeaderSwitcher({ prefs, onChange }) {
  const [langs, setLangs] = useState([]);
  useEffect(() => { api.get("/languages/ui-availability").then(r => setLangs(r.data)).catch(() => {}); }, []);

  const save = async (patch) => {
    try {
      const { data } = await api.put("/prefs", patch);
      onChange?.(data);
      toast.success("Preferences updated");
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!prefs) return null;
  return (
    <div className="k-container" data-testid="header-switcher"
      style={{ padding: "12px 16px", display: "flex", gap: 18, alignItems: "center", flexWrap: "wrap" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Gauge size={15} color="var(--accent)" />
        <span className="k-muted" style={{ fontSize: 12 }}>Explanation</span>
        <div style={{ display: "flex", gap: 4 }} data-testid="mode-switcher">
          {MODES.map(m => (
            <button key={m.key} data-testid={`mode-${m.key}`}
              className={`k-badge ${prefs.explanation_mode === m.key ? "k-badge-accent" : ""}`}
              style={{ cursor: "pointer" }} onClick={() => save({ explanation_mode: m.key })}>{m.label}</button>
          ))}
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Languages size={15} color="var(--accent)" />
        <select className="k-control" data-testid="language-select" style={{ width: "auto", padding: "6px 10px" }}
          value={prefs.language} onChange={e => save({ language: e.target.value })}>
          {langs.map(l => (
            <option key={l.code} value={l.code} disabled={l.status !== "live"}>
              {l.name}{l.status !== "live" ? ` — coming (tier ${l.tier})` : ""}
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span className="k-muted" style={{ fontSize: 12 }}>Complexity</span>
        <select className="k-control" data-testid="complexity-select" style={{ width: "auto", padding: "6px 10px" }}
          value={prefs.complexity} onChange={e => save({ complexity: e.target.value })}>
          {COMPLEXITY.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      <label className="k-muted" style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
        <input type="checkbox" data-testid="register-mirroring-toggle" checked={!!prefs.register_mirroring}
          onChange={e => save({ register_mirroring: e.target.checked })} />
        Register mirroring
      </label>
    </div>
  );
}
